import { ResponseWrapper, ErrorWrapper } from './utils';
import getEnv from '@/utils/env';

const API_URL =
  getEnv('VUE_APP_AUTH_HOST') ||
  process.env.VUE_APP_AUTH_HOST ||
  'https://localhost:4000';

import axiosInstance from '@/services/api/http.service';

// This is a interface which extendds
export class CloudService {
  static get entity() {
    return 'custom';
  }

  /**
   ******************************
   * @API
   ******************************
   */
  static async getAllVendors() {
    try {
      const response = await new axiosInstance({ auth: true }).get(
        `${API_URL}/cloud/vendors`,
      );
      // const response = await axiosInstance({ auth: true }).get(API_URL+`/dashboard/` + id);
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async getInstalledVendors() {
    try {
      const response = await new axiosInstance({ auth: true }).get(
        `${API_URL}/cloud/client/vendors`,
      );
      // const response = await axiosInstance({ auth: true }).get(API_URL+`/dashboard/` + id);
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async getAllProjects(vendor) {
    try {
      const response = await new axiosInstance({
        auth: true,
      }).get(`${API_URL}/cloud/project?vendor=${vendor}`);
      // const response = await axiosInstance({ auth: true }).get(API_URL+`/dashboard/` + id);
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async uploadProject(projectData) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/cloud/service_account`,
        projectData,
      );
      // const response = await axiosInstance({ auth: true }).get(API_URL+`/dashboard/` + id);
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async editProject(projectData) {
    try {
      const response = await new axiosInstance({ auth: true }).patch(
        `${API_URL}/cloud/project`,
        projectData,
      );
      // const response = await axiosInstance({ auth: true }).get(API_URL+`/dashboard/` + id);
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async deleteCloudSvc(vendorName) {
    try {
      const reqPayload = { vendor: vendorName };

      const response = await new axiosInstance({
        auth: true,
      }).delete(`${API_URL}/cloud/project/bulk`, { data: reqPayload });
      // const response = await axiosInstance({ auth: true }).get(API_URL+`/dashboard/` + id);
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async getVendorSvc(id) {
    try {
      const response = await new axiosInstance({
        auth: true,
      }).get(`${API_URL}/cloud/vendors/services?vendorId=${id}`);
      // const response = await axiosInstance({ auth: true }).get(API_URL+`/dashboard/` + id);
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async getAwsAccounts() {
    try {
      const response = await new axiosInstance({ auth: true }).get(
        `${API_URL}/cloud/aws/configurations`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      console.log('Error: ', error);
      throw new ErrorWrapper(error);
    }
  }
  static async getAwsAccountConnectionNames() {
    try {
      const response = await new axiosInstance({ auth: true }).get(
        `${API_URL}/cloud/aws/connection_names`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      console.log('Error: ', error);
      throw new ErrorWrapper(error);
    }
  }
  static async createAwsConnection(params) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `/cloud/aws/configure`,
        params,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async editAwsConnection(params) {
    try {
      const response = await new axiosInstance({ auth: true }).put(
        `/cloud/aws/configure`,
        {
          accessKeyId: params.accessKey,
          secretAccessKey: params.accessSecret,
          pullFrequency: params.pullInterval,
          connectionName: params.connectionName,
          aliasEnabled: params.aliasEnabled ? 1 : 0,
          subscriptionId: params.subscriptionId,
        },
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async deleteAwsAccount(subscriptionId) {
    try {
      const response = await new axiosInstance({ auth: true }).delete(
        `${API_URL}/cloud/aws/configuration/${subscriptionId}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      console.log('Error: ', error);
      throw new ErrorWrapper(error);
    }
  }
  static async getInstalledServices(params) {
    try {
      const response = await new axiosInstance({ auth: true }).get(
        `/cloud/aws/services-installed/${params.subscriptionId}`,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async handleServiceLevelAutoInstall(params) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `/cloud/aws/install-service`,
        {
          isAutoInstall: true,
          ...params,
        },
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async handleAutoInstallAll(params) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `/cloud/aws/install-all-services`,
        params,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async toggleMonitoring(params) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `/cloud/aws/toggle-monitoring`,
        {
          ...params,
        },
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async installServicesManually(params) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        '/cloud/aws/install-service',
        {
          ...params,
        },
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      console.log(error);
      throw new ErrorWrapper(error);
    }
  }
  static async getServicesInfo(params) {
    try {
      const response = await new axiosInstance({ auth: true }).get(
        `/cloud/aws/service-info/${params.subscriptionId}/${params.service}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async getGlobalFrequency(params) {
    try {
      const response = await new axiosInstance({ auth: true }).get(
        `/cloud/aws/global-pullfrequency-mins/${params.subscriptionId}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async updateServiceInfo(params) {
    try {
      const response = await new axiosInstance({ auth: true }).put(
        '/cloud/aws/install-service',
        { ...params },
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getConfigurationInfoBySubscriptionId(subscriptionId) {
    try {
      const response = await new axiosInstance({ auth: true }).get(
        `/cloud/aws/configurations/${subscriptionId}`,
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getAvailableServices(params) {
    try {
      const response = await new axiosInstance({ auth: true }).get(
        `/cloud/aws/service-discovery/${params.subscriptionId}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getForceUpdate(params) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `/cloud/aws/resource-force-update/${params.subscriptionId}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
